import { BaseModel } from "../../Bases/BaseModel";

export class Veiculo extends BaseModel {
    constructor(
        public placa = '',
        public renavan = '',
        public marca = '',
        public modelo = '',
        public ano = '',
        public capacidade = '',
        public numero_frota = '',
        public numero_antt = '',
        public validade_antt = '',
        public proprietario = '',
        public proprietario_cpfcnpj = '',
        public end_cep = '',
        public end_rua = '',
        public end_numero = '',
        public end_complemento = '',
        public end_bairro = '',
        public end_cidade = '',
        public end_uf = '',
        public id_rastreador = '',
        public id_rastreador_sec = '',
    ) {
        super();
    }
}

